class NotificationService {
  private permission: NotificationPermission = 'default';
  private isSupported: boolean = false;

  constructor() {
    this.isSupported = 'Notification' in window;
    if (this.isSupported) {
      this.permission = Notification.permission;
    }
  }

  async requestPermission(): Promise<boolean> {
    if (!this.isSupported) {
      console.warn('Browser notifications are not supported');
      return false;
    }

    if (this.permission === 'granted') {
      return true;
    }

    try {
      const permission = await Notification.requestPermission();
      this.permission = permission;
      return permission === 'granted';
    } catch (error) {
      console.error('Failed to request notification permission:', error);
      return false;
    }
  }

  async showNotification(title: string, options?: NotificationOptions): Promise<void> {
    if (!this.isSupported) {
      console.warn('Browser notifications are not supported');
      return;
    }

    if (this.permission !== 'granted') {
      const granted = await this.requestPermission();
      if (!granted) {
        console.warn('Notification permission not granted');
        return;
      }
    }

    try {
      const notification = new Notification(title, {
        icon: '/logo192.png',
        badge: '/logo192.png',
        ...options,
      });

      // Auto-close after 5 seconds
      setTimeout(() => {
        notification.close();
      }, 5000);

      // Focus window when notification is clicked
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    } catch (error) {
      console.error('Failed to show notification:', error);
    }
  }

  showMessageNotification(fromDevice: string, messageType: 'text' | 'image' | 'files', preview?: string): void {
    const title = `New message from ${fromDevice}`;
    let body: string;
    
    if (messageType === 'image') {
      body = '📷 Image message';
    } else if (messageType === 'files') {
      body = '📎 File message';
    } else {
      body = preview && preview.length > 100 
        ? `${preview.substring(0, 100)}...` 
        : preview || 'New message';
    }

    this.showNotification(title, {
      body,
      tag: 'buffer-message', // Replaces previous notifications
      requireInteraction: false,
      silent: false,
    });
  }

  isNotificationSupported(): boolean {
    return this.isSupported;
  }

  getPermission(): NotificationPermission {
    return this.permission;
  }
}

export const notificationService = new NotificationService();






